export const storeGame = (name, game) => {
    localStorage.setItem(name, JSON.stringify(game));
};
export const readGame = (name) => {
    const game = localStorage.getItem(name);
    if (game) {
        return JSON.parse(game);
    }
    else {
        throw new Error('Game not found');
    }
};
export const readGameType = () => {
    const gameType = localStorage.getItem('gameType');
    if (gameType) {
        return JSON.parse(gameType);
    }
    throw new Error('Game type not found');
};
export const storeGameType = (gameType) => {
    localStorage.setItem('gameType', JSON.stringify(gameType));
};
